<template>
	<el-dialog :close-on-click-modal="false"  :title="$t('layout.apiSet')" :visible.sync="apikeyModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表單内容 -->
		
		<el-form v-loading="load" :rules="info_rules" ref="form_info" :model="form_info" label-width="100px">
			
			<el-form-item :label="$t('live.use_time')" prop="app">
				<el-tag size="small" effect="plain" class="time-tag">
				  {{ form_info.use_time ? form_info.use_time : $t('live.noUse') }}
				</el-tag>
			</el-form-item>
			 
			<el-form-item :label="$t('live.nowkey')" prop="key">
				<div style="display: flex;align-items: center;">
					<el-input v-model="form_info.key"  clearable size="small" :placeholder="$t('live.nowkey')"  style="width: 58%;"></el-input>
					
					<el-tooltip :content="$t('match.apikeyTis')" effect="dark" placement="top">
							
							<el-button size="mini" type="text">
								 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
							</el-button>
							
						</el-tooltip>
					
					<i class="iconfont icon-fuzhi icon-copy ml-3" @click="copyText(form_info.key)"></i>
					<el-link class="ml-3 text-info" type="success"  @click="rangKey(1)">随机生成</el-link>
					
					
				</div>
				
				
			</el-form-item>
			
			
			<!-- IP白名单 -->
			<el-form-item   :label="$t('match.ipw')" prop="ip_data">
			 	<el-input  @input="handleIpInput"  v-model="form_info.ip_data" type="textarea" :rows="6"  :placeholder="$t('match.inpipData')" clearable size="small" style="width: 55%;"></el-input>						<el-tooltip :content="$t('match.ipwTis')" effect="dark" placement="top">
											
								<el-button size="mini" type="text">
									 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
								</el-button>
								
							</el-tooltip>
			 </el-form-item>
		
			
	
		</el-form>
	
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<el-button :disabled="load" :loading="load" type="primary" @click="submitinfo">{{$t('safe.sub')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			apikeyModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				ipStatus:false,
				info:{},
				ipdata:'',
				google_status:0,
				load:false,
				activeName:'1',
				editStatus:false,
				form_info:{
					key:'',
					use_time:'',
					ip_data:''
				},
				info_rules: {
					key: [
					  {
					    required: true,
					    message: this.$t('live.inpnowkey'),
					    trigger: 'blur',
					  },
					  {
					    len: 32,
					    message: this.$t('live.inpnowkey32'),
					    trigger: 'blur',
					    transform: v => (typeof v === 'string' ? v.trim() : v),
					  },
					],
				
		
				},
			}
		},
		watch:{
			apikeyModel(newVal) {
				if(newVal){
					this.editStatus = false
					this.getInfo()
				}
			}
		},
		methods:{
			
		
			hide(){
				this.$emit('hide')
			},
			
			rangKey(type){
				const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    let key = '';
				    for (let i = 0; i < 32; i++) {
				      key += chars.charAt(Math.floor(Math.random() * chars.length));
				    }
					
					if(type==1){
						this.form_info.key = key
					} 
			},
			copyText(text) {
			  
				//console.log(111)
			  navigator.clipboard.writeText(text)
				.then(() => {
				  this.$message.success(this.$t('cdn.copy_ok'));
				})
				.catch(() => {
				  this.$message.error(this.$t('cdn.copy_fail'));
				});
			},
			
			
			submitinfo(){
				this.$refs.form_info.validate(res => {
					if (res) {
						this.addSecret('ip',this.form_info);
						
					}
				})
			},
			getInfo(){
				this.load = true
				this.axios.post('/admin/user/userInfo', {type:'apikey'}, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.form_info = all.data.list
						
						console.log(all)
						// this.$message({
						// 	message:  all.msg,
						// 	type: 'success'
						// });
						// this.hide()
					}
					this.load = false
				}).catch(err => {
					this.load = false
				})
			},
			
		
			handleIpInput(val) {
				let num = 5
				console.log(num)
			    const lines = val.split('\n');
			    if (lines.length > num) {
			      this.form_info.ip_data = lines.slice(0, num).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('match.limitSource'));
			    }
			  },
			
			addSecret(){
				this.load = true
				this.axios.post('/admin/data/editUserKey', this.form_info, {
					token: true
				}).then(res => {
					let all = res.data
					console.log(all)
					
					if (all.code == 1) {
						this.$message({
							message:  all.msg,
							type: 'success'
						});
					}
					
					this.load = false
				}).catch(err => {
					this.load = false
				})
			},
			
			
		}
	}
</script>

<style>
	.key-right {
	  display: flex;
	  align-items: center;

	}
	
	.small-label {
	  color: #909399;
	  font-size: 13px;
	}
	
	.time-tag {
	  font-size: 13px;
	 
	}
</style>
